import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { query } from '../graphql'

/**
 * Vom Talent hochgeladene Dateien eines Space ({ key, size, lastModified }).
 *
 * Die Dokumente-Sektion und der PDF-Dialog lesen dieselbe Liste. Ueber den
 * gemeinsamen Query-Key geht dafuer nur ein Request raus.
 */
export const useSpaceFiles = (spaceId) =>
  useQuery({
    queryKey: QUERY_KEYS.spaceFiles(spaceId),
    queryFn: async () => {
      const response = await query({
        query: 'fileControl',
        variables: { space_id: spaceId, action: 'listFilesForSpace' }
      })

      const responseData = JSON.parse(response)
      const bodyData = responseData?.body && JSON.parse(responseData.body)

      return Array.isArray(bodyData?.files) ? bodyData.files : []
    },
    enabled: !!spaceId,
    // Frueher gab es gar keinen Retry. Drei mit Backoff hielten die
    // Dokumente-Sektion bei einem Fehler sieben Sekunden im Ladezustand.
    retry: 1
  })
